import React, { Dispatch, SetStateAction, useState } from "react";
import styled from "styled-components";
import CalendarLineBtn from "../../../../Button/CalendarLineBtn";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import CalendarModal from "../../../../Modal/CalendarModal";
import {
  CommentTargetContainer,
  ModalLabel,
} from "../CommentModal/TargetContainer";
import { ModalRow } from "./BlackListModal";

interface BlackListDateRowProps {
  modalType?: string;
  startDate: string;
  setStartDate: Dispatch<SetStateAction<string>>;
  endDate: OptionType;
  setEndDate: Dispatch<SetStateAction<OptionType>>;
}

export default function BlackListDateRow({
  modalType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}: BlackListDateRowProps) {
  const [startDateClick, setStartDateClick] = useState(false);

  const endDateList = [
    {
      value: "7_d",
      label: "7일",
    },
    {
      value: "1_M",
      label: "1개월",
    },
    {
      value: "6_M",
      label: "6개월",
    },
    {
      value: "1_y",
      label: "1년",
    },
    {
      value: "10_y",
      label: "10년",
    },
  ];

  return (
    <ModalRow>
      <ModalLabel>기간</ModalLabel>

      <CommentTargetContainer>
        <LineBoxContainer>
          {modalType === "view" ? (
            <DateViewBox>
              <span className="material-symbols-outlined">date_range</span>
              {startDate}
            </DateViewBox>
          ) : (
            <CalendarLineBtn
              onClickEvent={() => setStartDateClick(true)}
              value={startDate}
              initValue={"시작일"}
              disabled={modalType === "view"}
            />
          )}

          {startDateClick && (
            <CalendarModal
              closeEvent={() => setStartDateClick(false)}
              changeEvent={(date: string) => setStartDate(date)}
            />
          )}
        </LineBoxContainer>

        <LineBoxContainer>
          {modalType === "view" ? (
            <DateViewBox>
              <span className="material-symbols-outlined">date_range</span>
              {endDate?.label}
            </DateViewBox>
          ) : (
            <DropDown
              optionList={endDateList}
              dropdownValue={endDate}
              setDropDownValue={setEndDate}
              isDisabled={startDate === "시작일" || modalType === "view"}
              boxWidth={160}
            />
          )}
        </LineBoxContainer>
      </CommentTargetContainer>
    </ModalRow>
  );
}

const LineBoxContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const DateViewBox = styled.div`
  cursor: not-allowed;
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #808080;
  background-color: ${({ theme }) => theme.color.bgColor};
  border-radius: 3px;

  span {
    font-size: 18px;
    color: #858c97;
    margin-right: 4px;
  }
`;
